import { LINE_HEIGHT_BASE } from '../themeConstants'

export const muiComponentsMenuItem = {
  MuiMenuItem: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: 10,
        fontSize: 'var(--app-font-size-popup)',
        fontWeight: 'var(--app-font-weight-regular)',
        lineHeight: LINE_HEIGHT_BASE,
        color: theme.palette.text.primary,
        minHeight: 24,
        paddingTop: 2,
        paddingBottom: 2,
        paddingLeft: 4,
        paddingRight: 4,
        columnGap: 6,
        '& .MuiListItemIcon-root': {
          minWidth: 22,
        },
        '&:hover': {
          backgroundColor: theme.palette.action.hover,
        },
        '&.Mui-focusVisible': {
          outline: `2px solid ${theme.palette.primary.main}`,
          outlineOffset: -1,
        },
      }),
    },
  },
}
